import { motion } from "framer-motion";
import { Heart, X, MapPin } from "lucide-react";
import { dynamicLabel, timelineLabel } from "../lib/api";
import { FALLBACK_PHOTO } from "../lib/ui";

export const DiscoverProfileCard = ({ profile: p, index, onSwipe }) => (
  <motion.article
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, x: -40 }}
    transition={{ duration: 0.6, delay: Math.min(index * 0.08, 0.4) }}
    data-testid={`profile-card-${p.id}`}
    className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 bg-[#F3F0EA] border border-[#E5E0D8]"
  >
    <div className="md:col-span-5 relative min-h-[320px] md:min-h-[420px]">
      <img
        src={p.photo_url || FALLBACK_PHOTO}
        alt={p.name}
        className="absolute inset-0 w-full h-full object-cover"
      />
    </div>
    <div className="md:col-span-7 p-8 sm:p-12 flex flex-col">
      <div className="flex items-baseline gap-4 flex-wrap">
        <h2 className="font-serif text-3xl sm:text-4xl">{p.name}</h2>
        <span className="text-[#5C5C5C] text-lg">{p.age}</span>
      </div>
      <p className="mt-2 flex items-center gap-1.5 text-sm text-[#8A8A8A]">
        <MapPin className="w-3.5 h-3.5" strokeWidth={1.5} /> {p.location}
      </p>
      <div className="mt-6 flex flex-wrap gap-3">
        <span className="bg-[#7A3B3F] text-[#FAF9F6] px-4 py-1.5 text-xs uppercase tracking-[0.15em]">
          {dynamicLabel(p.relationship_dynamic)}
        </span>
        <span className="border border-[#4A5D4E] text-[#4A5D4E] px-4 py-1.5 text-xs uppercase tracking-[0.15em]">
          Marriage: {timelineLabel(p.marriage_timeline)}
        </span>
      </div>
      <p className="mt-8 text-[#5C5C5C] leading-relaxed text-lg">{p.bio}</p>
      {p.values?.length > 0 && (
        <div className="mt-6 flex flex-wrap gap-2">
          {p.values.map((v) => (
            <span key={v} className="text-xs capitalize text-[#8A8A8A] border border-[#E5E0D8] px-3 py-1">
              {v}
            </span>
          ))}
        </div>
      )}
      <div className="mt-auto pt-10 flex gap-4">
        <button
          data-testid={`pass-button-${p.id}`}
          onClick={() => onSwipe(p, "pass")}
          className="flex items-center gap-2 border border-[#1A1A1A] px-8 py-4 hover:bg-[#1A1A1A] hover:text-[#FAF9F6] transition-colors duration-300"
        >
          <X className="w-4 h-4" strokeWidth={1.5} /> Pass
        </button>
        <button
          data-testid={`like-button-${p.id}`}
          onClick={() => onSwipe(p, "like")}
          className="flex items-center gap-2 bg-[#7A3B3F] text-[#FAF9F6] px-8 py-4 hover:bg-[#5D2B2E] transition-colors duration-300"
        >
          <Heart className="w-4 h-4" strokeWidth={1.5} /> Interested
        </button>
      </div>
    </div>
  </motion.article>
);
